var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-choose-replacement flex flex-auto flex-col" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
        },
        [_c("ShippingEligibilityInfo", { ref: "eligibility" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm._v("\n    Choose the replacement item\n  "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(
          "\n    Please select the item you would like to get instead of one you have.\n  "
        ),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-card",
        {
          staticClass: "item-card replacement-items-view",
          staticStyle: { margin: "0px !important", "min-height": "96px" },
        },
        [
          _c(
            "div",
            {
              staticClass: "item-image",
              staticStyle: { margin: "0px !important" },
            },
            [_c("DeviceImage", { attrs: { device: _vm.device } })],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-auto", staticStyle: { "margin-left": "8px" } },
            [
              _c("div", { staticClass: "flex flex-row" }, [
                _c("div", { staticClass: "flex-1 text" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.deviceDescription) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.device.profile && _vm.device.profile.color
                ? _c("div", { staticClass: "colour" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.device.profile.color) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm.bestMatchFound === false
        ? _c(
            "div",
            { staticStyle: { display: "flex", padding: "16px 24px" } },
            [
              _c(
                "div",
                {
                  staticClass: "errormsg",
                  staticStyle: {
                    width: "987px",
                    display: "flex",
                    "align-items": "center",
                    "justify-content": "center",
                    height: "84px",
                    border: "1px solid var(--tertiary-500, #DEE5EC)",
                    color: "var(--tertiary-700, #81919F)",
                    "font-feature-settings": "'clig' off, 'liga' off",
                  },
                },
                [
                  _vm._v(
                    "\n      All the matching devices are out of stock or have shipping restrictions. Please contact your supervisor for assistance.\n    "
                  ),
                ]
              ),
            ]
          )
        : _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.bestMatch.ux_properties.loading,
                  expression: "bestMatch.ux_properties.loading",
                },
              ],
            },
            [
              _c(
                "el-card",
                {
                  staticClass: "item-card replacement-items-view",
                  staticStyle: {
                    margin: "0px !important",
                    "min-height": "96px",
                  },
                },
                [
                  !_vm.bestMatch.shipping_eligible
                    ? _c(
                        "div",
                        {
                          staticClass: "flex flex-row",
                          staticStyle: { position: "absolute", right: "0" },
                        },
                        [
                          _vm.expedited
                            ? _c("span", { staticClass: "expedited" }, [
                                _vm._v("Expedited"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "shipping-restrictions-label" },
                            [_vm._v("Shipping Restrictions Apply")]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "item-image",
                      staticStyle: { margin: "0px !important" },
                    },
                    [_c("DeviceImage", { attrs: { device: _vm.bestMatch } })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "flex-auto",
                      staticStyle: { "margin-left": "8px" },
                    },
                    [
                      _c("div", { staticClass: "flex flex-row" }, [
                        _c("div", { staticClass: "flex-1 text" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.bestMatch.product.description) +
                              " - Stock " +
                              _vm._s(_vm.bestMatch.stock) +
                              "\n          "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "colour" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.bestMatch.color) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.bestMatch.estimated_delivery
                        ? _c("div", { staticClass: "estimated-delivery" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.bestMatch.estimated_delivery) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.bestMatch.out_of_stock
                        ? _c(
                            "div",
                            {
                              staticClass: "device-status",
                              staticStyle: { "align-self": "flex-end" },
                            },
                            [_vm._v("\n          Out of Stock\n        ")]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
      _vm._v(" "),
      _vm.isSupervisor
        ? _c(
            "div",
            { staticStyle: { "padding-top": "8px", "padding-bottom": "8px" } },
            [
              _vm._v(
                "\n    The new product is determined by the best match algorithm.\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.anyReplacementAvailable
        ? _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "padding-top": "24px",
                "align-items": "center",
              },
            },
            [
              !_vm.showReplacementOptions
                ? _c(
                    "a",
                    {
                      staticClass: "showtext",
                      on: {
                        click: function ($event) {
                          return _vm.showOptions()
                        },
                      },
                    },
                    [_vm._v("\n      Show Other Options\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showReplacementOptions
                ? _c(
                    "a",
                    {
                      staticClass: "showtext",
                      on: {
                        click: function ($event) {
                          return _vm.hideOptions()
                        },
                      },
                    },
                    [_vm._v("\n      Hide Other Options\n    ")]
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showReplacementOptions
        ? _c("div", { staticClass: "frame" }, [
            _c(
              "div",
              { staticStyle: { "padding-top": "8px", "margin-bottom": "8px" } },
              [
                _c("el-input", {
                  staticClass: "searchbox",
                  attrs: { type: "text", placeholder: "Search", clearable: "" },
                  on: { clear: _vm.setSelectedOptionAsBestMatch },
                  model: {
                    value: _vm.searchValue,
                    callback: function ($$v) {
                      _vm.searchValue = $$v
                    },
                    expression: "searchValue",
                  },
                }),
                _vm._v(" "),
                _vm.noResultFound
                  ? _c(
                      "div",
                      {
                        staticStyle: { display: "flex", padding: "16px 24px" },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "errormsg",
                            staticStyle: {
                              width: "987px",
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "center",
                              height: "84px",
                              border: "1px solid var(--tertiary-500, #DEE5EC)",
                              color: "var(--tertiary-700, #81919F)",
                              "font-feature-settings": "'clig' off, 'liga' off",
                            },
                          },
                          [
                            _vm._v(
                              "\n          No devices matching your search request found. Please try another one.\n        "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "overflow-y": "scroll", height: "60vh" } },
              _vm._l(_vm.matchingReplacements, function (item) {
                return _c("div", { key: item.id }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: item.ux_properties.loading,
                          expression: "item.ux_properties.loading",
                        },
                      ],
                      staticClass: "replacement-options-items-view",
                    },
                    [
                      _c(
                        "el-card",
                        {
                          staticClass: "item-card",
                          class: {
                            "highlighted-item-card": _vm.isItemSelected(item),
                            "item-card--unavailable":
                              item.out_of_stock ||
                              item.shipping_eligible === false,
                          },
                        },
                        [
                          !item.shipping_eligible
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    position: "absolute",
                                    right: "4rem",
                                  },
                                },
                                [
                                  _vm.expedited
                                    ? _c(
                                        "span",
                                        { staticClass: "expedited item" },
                                        [_vm._v("Expedited")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "shipping-restrictions-label item",
                                    },
                                    [_vm._v("Shipping Restrictions Apply")]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "item-image",
                              staticStyle: { margin: "0px !important" },
                            },
                            [_c("DeviceImage", { attrs: { device: item } })],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "flex-auto",
                              staticStyle: { "margin-left": "8px" },
                            },
                            [
                              _c("div", { staticClass: "flex flex-row" }, [
                                _c("div", { staticClass: "item-name flex-1" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.product.description) +
                                      " - Stock " +
                                      _vm._s(item.stock) +
                                      "\n                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              item.color
                                ? _c("div", { staticClass: "item-sku" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("capitalize")(item.color)
                                        ) +
                                        "\n              "
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.estimated_delivery
                                ? _c(
                                    "div",
                                    { staticClass: "estimated-delivery" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item.estimated_delivery) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.out_of_stock
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "device-status",
                                      staticStyle: { "align-self": "flex-end" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Out of Stock\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedOption,
                                expression: "selectedOption",
                              },
                            ],
                            staticClass: "radio",
                            staticStyle: {
                              "margin-right": "16px",
                              "border-radius": "4px",
                              width: "24px",
                              height: "24px",
                              "align-self": "center",
                              "accent-color": "#1998D5",
                            },
                            attrs: {
                              type: "radio",
                              name: "options",
                              disabled:
                                item.shipping_eligible === false ||
                                item.out_of_stock,
                            },
                            domProps: {
                              value: item.id,
                              checked: _vm._q(_vm.selectedOption, item.id),
                            },
                            on: {
                              change: [
                                function ($event) {
                                  _vm.selectedOption = item.id
                                },
                                function ($event) {
                                  return _vm.toggleSelection(item)
                                },
                              ],
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "24px" } }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "flex-1" }, [
          _vm._v("\n        Old Product\n      "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "24px" } }, [
      _c("div", { staticClass: "section-header" }, [
        _c("div", { staticClass: "flex-1" }, [
          _vm._v("\n        Best Match\n      "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }